import e from "../../utils/classNames.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/applicationLayout/ApplicationLayoutSidebar.tsx
var r = t((t, r) => {
	let { className: i, children: a, ...o } = t, s = e("ApplicationLayoutSidebar", i);
	return /* @__PURE__ */ n("div", {
		ref: r,
		...o,
		className: s,
		children: a
	});
});
//#endregion
export { r as default };

//# sourceMappingURL=ApplicationLayoutSidebar.js.map